/* eslint-disable */

<template>
    <v-container container--fluid>
        <v-layout row wrap>
            <v-flex xs6>
                <qrcode-stream @init="onInit" @decode="onDecode"></qrcode-stream>
            </v-flex>
            <v-flex xs6>
                {{result}}
            </v-flex>
        </v-layout>0
        <v-layout row wrap>
            <v-flex xs6>
                {{ $store.state.user.roles }}
                <v-btn v-can="{obj_type:'master', action: 'edit'}">RRRRRRRRRRRRRR</v-btn>
                <v-form v-model="testMonicaValid">
                <NumericField dense outlined
                    v-model="testMonica"
                    :precision="myPrec"
                    :negative="false"
                    :rules=[rules.mandatory]
                    label="Test Monica cifre decimali"
                ></NumericField>
                <v-checkbox @change='changeTestMonica'>testMOnicaChange</v-checkbox>
                <CalendarField
                    v-model="testCalendarMonica"
                />
                
            </v-form>
            </v-flex>
            <v-flex xs6 pl-4>
                <v-btn color="success" @click="changePrecision">text changePrecision {{myPrec}}</v-btn>
                <v-btn color="success" @click="changeCalendarDate">text {{myPrec}}</v-btn><br/>
                <br/>
                testMonica: tipo: {{ typeof(testMonica)  }}, valore: {{ testMonica }} - validità: {{testMonicaValid}}
                calendar {{ (new Date(testCalendarMonica)).toISOString().substr(0, 10) }}
            </v-flex>
            <v-flex xs12>
                <v-btn color="success" @click="getFromTest">get from string</v-btn>
                test big number: {{myBigString}}
            </v-flex>
            <!--v-flex xs6>
                <v-text-field dense outlined v-for="(item, index) in items" :key="index"
                    v-model.number="item.testBlur"
                    type="number"
                    label="Test cifre decimali"
                    @blur="externalHandle(item)"
                ></v-text-field>
            </v-flex-->
            <v-flex xs12>
                <VueUploadComponent
                    ref="upload"
                    v-model="files"
                    @input-file="processFile"
                    @input-filter="inputFilter"
                    class="btn"
                    >
                    <v-btn> Seleziona file </v-btn>
                </VueUploadComponent>
                <v-text-field dense outlined
                v-model="equation"
                label="equazione da stampare"
                ></v-text-field>
                <p>Per ora l'oggetto che contiene i parametri ha 3 valori all'interno e tutti prendono il valore di input del prossimo textfield</p>
                <v-text-field dense outlined
                    label="inserisci il valore di a/b/c"
                    v-model="uInput"
                ></v-text-field>
               
            </v-flex>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex xs4>
                        <p>Questa è l'equazione "simbolica"</p>
                        <div v-katex:display=originale></div>
                    </v-flex>
                    <v-flex xs4>
                        <p>Risultato frazionario</p>
                        <div v-katex:display=equazione></div>
                    </v-flex>
                    <v-flex xs4>
                        <p>Risultato decimale</p>
                        <div v-katex:display=risolta></div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12>
                <v-layout row wrap>
                    <v-flex xs6>
                        <v-text-field dense outlined
                            label="caricato da DB"
                            v-model="testFormula.equation"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                        <div v-katex:display=risultatoSTD></div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-btn color="success" @click="execute">Ricalcolare tutto</v-btn>
        </v-layout>
    </v-container>
</template>
<script>
import VueUploadComponent from "vue-upload-component";
import { f_rules } from '../utils/commonUtils';
import CalendarField from '../components/utils/CalendarField'
import Big from "big.js"
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

const nerdamer = require('nerdamer/all');
export default {
    components:{
        VueUploadComponent, CalendarField,
        QrcodeStream,
        QrcodeDropZone,
        QrcodeCapture
    },
    data(){
        return {
            testMonica: '4',
            testMonicaValid: true,
            myPrec: 0,
            testCalendarMonica: 1593979803000,
            testBlur: '',
            myKey: "",
            equation: '2*sqrt((U1/2)^2 + (U2/(2*sqrt(3)))^2 + (U3/(2*sqrt(3)))^2)',
            uInput: 0,
            originale: '0',
            equazione: '0',
            risolta: '0',
            risultatoSTD: '0',
            testFormula: {},
            calcoloP: 'I + e*0.5 - AL',
            cPdata: {
                I: 3000,
                e: 10,
                AL: 5,
                testBlur: ''
            },
            items: [
                {testBlur: "", index: 1},
                {testBlur: "", index: 1},
                {testBlur: "", index: 1},
                {testBlur: "", index: 1},
            ],
            files: [],
            csv_example: ",Temperatura Acqua,Pressione vapore acqueo (Kpa),Densità Acqua (g/cm3)\n,10.0,1.2281,0.99970\n,10.1,1.2366,0.99969\n,10.2,1.2451,0.99968",
            rules: f_rules,
            myBig: null,
            myBigString: "",
            result: ""
        }
    },
    methods:{
        onDecode (result) {
            this.result = result
        },

        async onInit (promise) {
            try {
                await promise
            } catch (error) {
                if (error.name === 'NotAllowedError') {
                this.error = "ERROR: you need to grant camera access permission"
                } else if (error.name === 'NotFoundError') {
                this.error = "ERROR: no camera on this device"
                } else if (error.name === 'NotSupportedError') {
                this.error = "ERROR: secure context required (HTTPS, localhost)"
                } else if (error.name === 'NotReadableError') {
                this.error = "ERROR: is the camera already in use?"
                } else if (error.name === 'OverconstrainedError') {
                this.error = "ERROR: installed cameras are not suitable"
                } else if (error.name === 'StreamApiNotSupportedError') {
                this.error = "ERROR: Stream API is not supported in this browser"
                } else if (error.name === 'InsecureContextError') {
                this.error = 'ERROR: Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.';
                } else {
                this.error = `ERROR: Camera error (${error.name})`;
                }
            }
        },
        changeTestMonica() {
            this.testMonica = (Math.random() * (2000 - 10) + 10);
        },
        changeCalendarDate() {
            this.testCalendarMonica = this.testCalendarMonica+1000000000
        },
        changePrecision() {
            this.myPrec = this.myPrec+1
        },
        execute(){
           
            this.originale = nerdamer.convertToLaTeX(this.equation);
            var knownValues = {U1: 0.09, U2: 0.02, U3: 0.10 }
            var result = nerdamer(this.equation, knownValues);
            console.log("equazione con numeri ",result.text())
            this.equazione = result.toTeX();
            this.risolta = result.evaluate().toTeX('decimal');
            nerdamer.clear('all');
        },
        executeForReal(){
            if(this.testFormula.fixed_params){
                // let vals = Object.keys(this.testFormula.data)
                // for (let elm of vals){
                //     this.testFormula.data[elm] = 5
                // }
                // console.log(this.testFormula.data)
                var k = nerdamer(this.testFormula.equation, this.testFormula.data).evaluate()
                console.log("risultato ", k.text())
                this.risultatoSTD = nerdamer.convertToLaTeX(this.testFormula.equation).toString()
            } else {
                //TODO: come gestire funzioni multiparametro con # params variabile?
                let paramName = Object.keys(this.testFormula.data)[0] // name of the variable, like a in stdev(a)
                var temp = this.testFormula.equation.replace(paramName, this.testFormula.data[paramName].toString())
                this.risultatoSTD  = nerdamer.convertToLaTeX(temp).toString()
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(csv)$/i.test(newFile.name)) {
                return prevent()
                }
            }
        },
        processFile(){
            console.log("test file input", this.files[0])
            let pippo = this.$papa.parse(this.files[0].file, {header: true, complete: (results) => {
                console.log("results parsing", results)
                let cose = this.$papa.unparse(results)
                console.log("tentativo 2", cose)
                this.download("esempio.csv", cose)
            }})
        },
        download(filename, text) {
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        externalHandle(item){
            item.testBlur = this.handleBlur(item.testBlur)
        },
        externalHandle2(item) {
            this.testMonica = this.handleBlur2(item)
            console.log(typeof this.testMonica)
        },
        handleBlur(value, decimals){
                // Number(Math.round(parseFloat(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces)
                var num = 0
                var str = ""
                // let value = data.testBlur
                let idx_comma = value.lastIndexOf(",")
                let idx_dot = value.lastIndexOf(".")
                if(idx_dot > idx_comma){
                    str = value.replace(/.(?=[^.]*$)/, '@')
                } else {
                    str = value.replace(/,(?=[^,]*$)/, '@')
                }
                if(str.indexOf(".") > 0){
                    str = str.replace(/./g, "")
                }
                if(str.indexOf(",") > 0){
                    str = str.replace(/,/g, "")
                }
                num = str.replace("@", ".")
                return Number(Math.round(parseFloat(num + 'e' + decimals)) + 'e-' + decimals).toFixed(decimals).replace(".",",")
                // console.log("ciao ciao", this.cPdata.testBlur, value)
                // this.testBlur = num.toLocaleString("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
        },
        handleBlur2(value, decimals){
                // Number(Math.round(parseFloat(value + 'e' + decimalPlaces)) + 'e-' + decimalPlaces)
                let a = new Intl.NumberFormat('it', { minimumFractionDigits:decimals, maximumFractionDigits: decimals, useGrouping:false }).format(value)
                return a
                // console.log("ciao ciao", this.cPdata.testBlur, value)
                // this.testBlur = num.toLocaleString("it-IT", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
        },
        getFromTest(){
            this.myBig = this.myBig.plus(this.testMonica)
            this.myBigString = this.myBig.toString()
        }
    },
    async beforeMount(){
        // let b_sel = {doc_type: 'formula', "_id": "formula_P"}
        // let res = await this.$store.state.$pouch.find('masters', {selector: b_sel})
        // // console.log('query', b_sel);
        // // console.log('formule', res);
        // this.testFormula = res.docs[0]
        // this.executeForReal()

        // var result =  this.$papa.parse(this.csv_example,{header:true, dynamicTyping : true})
        // console.log("tentativo di parsing", result)
      
        // var risolto = this.$papa.unparse(result.data)
        // console.log("tentativo di sabotaggio\n", risolto)
        this.myBig = new Big("0.3245")
        console.log("$$", this.myBig)
        this.myBigString = this.myBig.toString()
    }
}
</script>